export default __webpack_public_path__ + "static/media/too-many-works-line.6d89b71d.png";